module.exports = __webpack_public_path__ + "img/d7fc6dc4e1e983610cd46d9041779620.png";